// KDS's names for data-platform's room IDs (camera_rooms.json `rooms`), the only form VSS, the kitchen events and the
// todo service carry. Renaming a room here renames it in KDS alone; a value that is not a known ID shows as it is.
export const KITCHEN_ROOM_NAMES: Readonly<Record<string, string>> = {
  BH001_bakery: 'Bakery',
  BH001_butchery: 'Butchery',
  BH001_calo_2_0_passage: 'Calo 2.0 Passage',
  BH001_calo_2_0_portioning_room: 'Calo 2.0 Portioning Room',
  BH001_chillers_corridor: 'Chillers Corridor',
  BH001_chillers_passage: 'Chillers Passage',
  BH001_cold_section: 'Cold Section',
  BH001_component_chiller_2: 'Component Chiller 2',
  BH001_dry_store: 'Dry Store',
  BH001_hot_section: 'Hot Section',
  BH001_hot_section_corridor: 'Hot Section Corridor',
  BH001_kitchen_entrance: 'Kitchen Entrance',
  BH001_lift_lobby: 'Lift Lobby',
  BH001_packing: 'Packing',
  BH001_portioning_room: 'Portioning Room',
  BH001_roasting_section: 'Roasting Section',
  BH001_sauce_section: 'Sauce Section',
  BH001_shopping_area: 'Shopping Area',
  BH001_vegetables_section: 'Vegetables Section',
  BH001_washing_station: 'Fruit & Vegetables Washing and Sanitation Station'
};

export const roomName = (room: string): string => KITCHEN_ROOM_NAMES[room] ?? room;
